import { KNOWLEDGEPOINT_CDN_URL } from 'bpm/shared/utils/urlUtils'

export const ERROR_DUPLICATE_PROPERTY = 'Duplicate property found!'
export const ERROR_DUPLICATE_MASTERSPEC_PROPERTY =
    'Property name found in MasterSpec!'
export const ERROR_DUPLICATE_OPTION = 'Option duplicate found!'
export const ERROR_DUPLICATE_HEADER = 'Duplicate header found!'
export const ERROR_EMPTY_FIELD = 'Input required'
export const ERROR_EMPTY_PROPERTY = 'At least one property required'
export const ERROR_CANNOT_REMOVE_OPTION =
    'Cannot remove this option. The selected option is either MasterSpec or is supported on another product.'
export const ERROR_CANNOT_REMOVE_PROPERTY = ({
    removable,
    nonRemovable,
}: {
    removable: string
    nonRemovable: string
}) =>
    `Cannot remove property(ies) ${nonRemovable}.This is/are either MasterSpec or is supported in other product/s. \nProperty(ies) ${removable} will be removed on save.`
export const ERROR_EMPTY_PROPERTYNAME =
    'Property name required. If you intend to delete this property, please remove the options'
export const PLACEHOLDER_HEADER = 'Header (Optional)'
export const PLACEHOLDER_PROPERTY = 'Property (required)'
export const HELPER_EMPTY_SUBPROPERTY_ERROR =
    'Please fill in empty property name field'
export const HELPER_GENERIC_SUBPROPERTY_ERROR =
    'Please address property name errors'
export const PROMPT_DISCARD_CHANGES =
    'Changes will not be saved. Are you sure you want to cancel?'
export const PROMPT_DELETE_PROPERTY =
    'The Property will be removed on the Product Type but will continue to be displayed on projects where it has been previously added. \nAre you sure you want to delete this property?'
export const PROMPT_DELETE_OPTION =
    'The Option will be removed on the Product Type but will continue to be displayed on projects where it has been previously added. \nAre you sure you want to delete this option?'
export const TITLE_DELETE_PREMIUM_PROPERTY = 'Delete Premium Plus Property'
export const TITLE_DISCARD_CHANGES = 'Discard Changes'
export const TITLE_DELETE_OPTION = 'Delete Option'

export const INFO_ICON_URL = `${KNOWLEDGEPOINT_CDN_URL}/InfoCircle.svg`
export const ADD_MANUFACTURER_OPTION_ICON_URL = `${KNOWLEDGEPOINT_CDN_URL}/AddManufacturer.svg`

export const MANUFACTURER_OPTION = 'Manufacturer option'
export const MANUFACTURER_OPTIONS = 'Manufacturer Options'
export const MASTERSPEC_OPTION = 'MasterSpec option'
export const PROPERTY_VALUE = 'Property value'
export const ADD_MANUFACTURER_OPTIONS = 'Add Manufacturer Options'
export const MASTERSPEC_OPTIONS = 'MasterSpec + Options'

export const MANUFACTURER_OPTION_INFO_DIALOG_TEXT =
    'The tabs below identify additional Manufacturer Options available per product in this Product Type. Please get in touch with your customer support representative for information on how to add options or choose from the available options to make them visible on your product.'
